export default __webpack_public_path__ + "static/media/net_abnormal@2x.90733ef4.png";